// extracted by mini-css-extract-plugin
export default {"tab":"Tabs_tab__4FS3+","tab-link":"Tabs_tab-link__UQiSP","tab-title":"Tabs_tab-title__4NB24","close-button":"Tabs_close-button__V3Grx","disabled":"Tabs_disabled__ln0sH"};